import { render, staticRenderFns } from "./ApprovalStatusBadge.vue?vue&type=template&id=5ca806c3&scoped=true"
import script from "./ApprovalStatusBadge.vue?vue&type=script&lang=ts"
export * from "./ApprovalStatusBadge.vue?vue&type=script&lang=ts"
import style0 from "./ApprovalStatusBadge.vue?vue&type=style&index=0&id=5ca806c3&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ca806c3",
  null
  
)

export default component.exports